import React from "react";
import { Button, FormFieldSet, Modal, useFormHandler } from "../../../../components";


const VoidModal = ({ open, onClose }) => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    reason: "",
  });

  const handleOk = () => {
    const isValid = validateAllFields();
    if (isValid) {
      //   onClose();
    }
  };
  return (
    <Modal isOpen={open} onClose={onClose} title="ALERT" width="max-w-2xl">
      <div className="px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <FormFieldSet
            type="textArea"
            placeholder="Enter Reason"
            title={"Reason to Void"}
            value={formData.reason || ""}
            onChange={(value) => handleChange("reason", value)}
            error={errors.reason}
          />
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <Button title={"Cancel"} variant="outlined" onClick={onClose} />
          <Button title={"Void"} onClick={() => handleOk()} />
        </div>
      </div>
    </Modal>
  );
};

export default VoidModal;
